const blogPosts = [
  {
    title: "Flutter State Management using Provider for Beginners",
    url: "https://medium.com/@dolapoolakanmi/flutter-state-management-using-provider-for-beginners-74b3d28cce22?sharedUserId=dolapoolakanmi",
    type: "Medium",
    gradient: "linear-gradient(135deg, #1d4ed8 0%, #14b8a6 100%)",
    thumbnail:
      "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title:
      "Using P12 Certificates for APNS Authorization in FCM Flutter Integration",
    url: "https://medium.com/@dolapoolakanmi/using-p12-certificates-for-apns-authorization-in-fcm-flutter-integration-a573ea2b9abb",
    type: "Medium",
    gradient: "linear-gradient(135deg, #0f172a 0%, #3b82f6 100%)",
    thumbnail:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Cryptography vs Encryption",
    url: "https://medium.com/@dolapoolakanmi/cryptography-vs-encryption-65b2f116b7e1",
    type: "Medium",
    gradient: "linear-gradient(135deg, #7c3aed 0%, #f59e0b 100%)",
    thumbnail:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title:
      "Using P12 Certificates for APNS Authorization in FCM Flutter Integration",
    url: "https://dev.to/dolapo_olakanmi_6ae9cf74f/using-p12-certificates-for-apns-authorization-in-fcm-flutter-integration-31el",
    type: "Dev.to",
    gradient: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)",
    thumbnail:
      "https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fkn6ezzczd63dc1dpvy5m.webp",
  },
  {
    title: "Flutter State Management using Provider (For Beginners)",
    url: "https://youtu.be/vn7T_Z9_5vs?si=5T1JqQmMUFKAQZ4q",
    type: "YouTube",
    gradient: "linear-gradient(135deg, #ef4444 0%, #f97316 100%)",
    thumbnail: "https://img.youtube.com/vi/vn7T_Z9_5vs/maxresdefault.jpg",
  },
];

function BlogsSection() {
  return (
    <section
      id="blogs"
      className="flex min-h-screen w-full items-center justify-center bg-[#2a2a2a] px-4 py-12 md:px-12"
    >
      <div className="mx-auto w-full max-w-6xl py-4">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-bold text-white md:text-4xl">Blogs</h2>
          <img
            src={require("../../asset/image/section-indicator.png")}
            alt="section indicator"
            className="mx-auto mt-3 block"
          />
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {blogPosts.map((post) => (
            <a
              key={post.title}
              href={post.url}
              target="_blank"
              rel="noreferrer"
              className="rounded-2xl border border-white/10 bg-[#f5f5f5] p-6 text-slate-800 shadow-lg shadow-black/20 transition hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="relative mb-4 h-32 overflow-hidden rounded-xl">
                <div
                  className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.2), rgba(15, 23, 42, 0.4)), url("${post.thumbnail}")`,
                  }}
                />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.35),transparent_35%)]" />
              </div>

              <span className="mb-3 inline-flex rounded-full bg-slate-200 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-700">
                {post.type}
              </span>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">
                {post.title}
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogsSection;
